import { Tooltip } from "@mui/joy";
import { SxProps } from "@mui/joy/styles/types";

import Warning from "../assets/icons/Warning";

const TagWarningIcon = ({ sx }: { sx?: SxProps }) => {
  return (
    <Tooltip
      title={
        <>
          <strong>No tag assigned.</strong>
          <br /> Customers will not be able to scan the tag
        </>
      }
      size="sm"
      placement="bottom-start"
    >
      <Warning sx={sx} size="sm" />
    </Tooltip>
  );
};

export default TagWarningIcon;
